module.exports = flarum.core.compat['tags/common/helpers/tagLabel'];